import { useMemo } from "react";
import { useSelector } from "react-redux";

export default () => {
    const { audits, auditAssignments } = useSelector((state) => state);

    const useOutdatedAudits = useMemo(() => {
        /** Get reissued audits from assignments */
        const reIssuedAuditIds = auditAssignments.data.reduce((acc, item) => {
            if (item.isReissued) acc.push(item.auditLocation.audit.id);
            return acc;
        }, []);

        const today = new Date();

        /** Reissued audits has 2 conditions
         * 1. If the audit end date is greater than today
         * 2. If the audit is not re-issued
         */
        return audits.data.filter(
            (item) =>
                today > new Date(item.endDate) &&
                !reIssuedAuditIds.includes(item.id)
        );
    }, [audits, auditAssignments]);

    return useOutdatedAudits;
};
